export default "__VITE_ASSET__CYzcftSS__"